export function formatVideoTime(seconds: number): string {
	if (!seconds || isNaN(seconds)) {
		return '00:00';
	}
	const mins = Math.floor(seconds / 60);
	const secs = Math.floor(seconds % 60);
	return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
}
